import React from "react";
import {
  MDBIcon,
  toast,
  ToastContainer,
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBModal,
  MDBModalBody,
  MDBModalHeader,
  MDBModalFooter,
  MDBBtn,
} from "mdbreact";
import { XInput, XSelect, XBtn, XDatePicker } from "../../Components/XForm";
import Loader from "../../Components/Loader";
import { API_CONFIG } from "../../Config/config-env.js";
import { applyExternalDarkMode } from "../../Config/functions";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import axios from "axios";

class reportArqueo2 extends React.Component {
  state = {
    optionsT: [
      { value: 47, checked: true, text: "Envio a Domicilio" },
      { value: 85, text: "Recojo en Tienda" },
    ],
    options: [],
    userNameXF: "",
    userType: 47,
    SKU: "",
    rows1: [],
    noData: false,
    rows2: [],
    skuExists: "NO ENCONTRADO",
    skuState: "SIN INFORMACION",
    showResults: false,
    data: [],
    resultado_final: 0,
    to_date: new Date(),
    from_date: new Date(),
    fecha: "",
    dotacion: 500,
    compinfo: {},
    tipo_cambio: 6.94, // valor por defecto; luego se leerá de una API
    facturas_finalizadas: 0,
    facturas_pendientes: 0,
    facturas_monto_finalizadas: 0,
    facturas_monto_pendientes: 0,
    facturas_monto_anuladas: 0,
    facturas_anuladas: 0,
    facturas_monto_total: 0,
    metodos: [
      {
        text: "EFECTIVO",
        value: "EFECTIVO",
        total: 0,
        monto_total: 0,
        retiro: 0,
        tipo: "E",
      },
      {
        text: "EFECTIVO ME",
        value: "EFECTIVO ME",
        total: 0,
        monto_total: 0,
        retiro: 0,
        tipo: "E",
      },

      {
        text: "TARJETA ATC",
        value: "TARJETA ATC",
        total: 0,
        monto_total: 0,
        retiro: 0,
        tipo: "T",
      },
      {
        text: "TARJETA LINKSER",
        value: "TARJETA LINKSER",
        total: 0,
        monto_total: 0,
        retiro: 0,
        tipo: "T",
      },
      {
        text: "QR ATC",
        value: "QR ATC",
        total: 0,
        monto_total: 0,
        retiro: 0,
        tipo: "C",
      },
      {
        text: "LINEA DE CREDITO IISA",
        value: "LINEA DE CREDITO IISA",
        total: 0,
        monto_total: 0,
        retiro: 0,
        tipo: "C",
      },
      {
        text: "TODOTIX",
        value: "TODOTIX",
        total: 0,
        monto_total: 0,
        retiro: 0,
        tipo: "C",
      },
      {
        text: "CONTRAENTREGA",
        value: "CONTRAENTREGA",
        total: 0,
        monto_total: 0,
        retiro: 0,
        tipo: "C",
      },

      {
        text: "QR BCP",
        value: "QR BCP",
        total: 0,
        monto_total: 0,
        retiro: 0,
        tipo: "C",
      },
    ],

    metodos_anuladas: [
      {
        text: "EFECTIVO",
        value: "EFECTIVO",
        total: 0,
        monto_total: 0,
        retiro: 0,
        tipo: "E",
      },
      {
        text: "EFECTIVO ME",
        value: "EFECTIVO ME",
        total: 0,
        monto_total: 0,
        retiro: 0,
        tipo: "E",
      },

      {
        text: "TARJETA ATC",
        value: "TARJETA ATC",
        total: 0,
        monto_total: 0,
        retiro: 0,
        tipo: "T",
      },
      {
        text: "TARJETA LINKSER",
        value: "TARJETA LINKSER",
        total: 0,
        monto_total: 0,
        retiro: 0,
        tipo: "T",
      },
      {
        text: "QR ATC",
        value: "QR ATC",
        total: 0,
        monto_total: 0,
        retiro: 0,
        tipo: "C",
      },
      {
        text: "LINEA DE CREDITO IISA",
        value: "LINEA DE CREDITO IISA",
        total: 0,
        monto_total: 0,
        retiro: 0,
        tipo: "C",
      },
      {
        text: "TODOTIX",
        value: "TODOTIX",
        total: 0,
        monto_total: 0,
        retiro: 0,
        tipo: "C",
      },
      {
        text: "CONTRAENTREGA",
        value: "CONTRAENTREGA",
        total: 0,
        monto_total: 0,
        retiro: 0,
        tipo: "C",
      },
      {
        text: "QR BCP",
        value: "QR BCP",
        total: 0,
        monto_total: 0,
        retiro: 0,
        tipo: "C",
      },
    ],

    fact_fin: 110,
    fact_pend: 0,
    fact_tot: 110,
    fact_nulas: 0,
    medios_efec: 110,
    medios_qr: 0,
    medios_atc: 0,
    fact_dely: 0,
    fact_todotix: 0,
    fact_bcp: 0,

    fact_iisa: 0,
    fact_total: 110,
    total_tarj_atc: 0,
    total_tarj_link: 0,
    conv_qr_red_enlace: 0,
    conv_ret_qr_red_enlace: 0,
    cuad_ret_efec: 0,
    cuad_ret_usd: 0,
    cuad_ret_dot: 0,
    conv_todotix: 0,
    conv_bcp: 0,
    conv_contraentrega: 0,
    conv_ssa: 0,

    conv_ret_todotix: 0,
    conv_ret_bcp: 0,
    conv_ret_contraentrega: 0,
    conv_ret_issa: 0,
    conv_ret_bcp: 0,

    retiro_tarj_link: 0,
    retiro_tarj_atc: 0,

    showConfirmModal: false,
    existingCierre: null,
    cierreAgencia: "",
    savingCierre: false,
    isAdmin: false,
  };

  componentDidMount = () => {
    applyExternalDarkMode(this.props.location.search);
    this.LoadSections(47);

    let f = new Date();
    let fecha =
      (f.getDate() < 10 ? "0" + f.getDate() : f.getDate()) +
      "/" +
      (f.getMonth() + 1 < 10 ? "0" + (f.getMonth() + 1) : f.getMonth() + 1) +
      "/" +
      (f.getFullYear() + "");

    var hora = f.getHours();
    var minuto = f.getMinutes() < 10 ? "0" + f.getMinutes() : f.getMinutes();
    var segundo = f.getSeconds() < 10 ? "0" + f.getSeconds() : f.getSeconds();

    if (hora > 12) {
      hora = hora - 12 + ":" + minuto + " PM";
    } else if (hora === 0) {
      hora = "12" + ":" + minuto + ":" + segundo + "AM";
    } else if (hora === 12) {
      hora = "12" + ":" + minuto + ":" + segundo + "PM";
    } else {
      hora = hora + ":" + minuto + ":" + segundo + "AM";
    }

    this.setState({ fecha: fecha + " " + hora });
  };

  generateReport = async () => {

    const numericFields = [
      { name: "dotacion", label: "Dotación" },
      { name: "cuad_ret_dot", label: "Retiro dotación" },
      { name: "cuad_ret_efec", label: "Retiro efectivo" },
      { name: "cuad_ret_usd", label: "Retiro USD" },
      { name: "retiro_tarj_atc", label: "Retiro tarj. ATC" },
      { name: "retiro_tarj_link", label: "Retiro tarj. Linkser" },
      { name: "conv_ret_qr_red_enlace", label: "Retiro QR ATC" },
      { name: "conv_ret_issa", label: "Retiro LINEA DE CREDITO IISA" },
      { name: "conv_ret_contraentrega", label: "Retiro CONTRAENTREGA" },
      { name: "conv_ret_todotix", label: "Retiro TODOTIX" },
      { name: "conv_ret_bcp", label: "Retiro QR BCP" }
    ];

    const tipoCambio = parseFloat(this.state.tipo_cambio);
    if (isNaN(tipoCambio) || tipoCambio <= 0) {
      toast.error(`El campo "Tipo de cambio" no es válido. Debe ser mayor a 0.`);
      return;
    }

    let isValid = true;
    let fieldInError = "";
    let labelInError = "";
    // Usamos un bucle for...of para poder usar 'break'
    for (const field of numericFields) {
      const value = this.state[field.name];
      const numValue = parseFloat(value);

      // Validamos: si no es número, es menor a 0, o está vacío
      if (isNaN(numValue) || numValue < 0 || value === "") {
        isValid = false;
        labelInError = field.label; // Guardamos el nombre bonito
        break;
      }
    }

    if (!isValid) {
      // El Toast ahora será mucho más claro para el usuario
      toast.error(`El campo "${labelInError}" no es válido. Debe ser 0 o mayor.`);
      return; // Bloquea la ejecución
    }

    let params = new URLSearchParams(this.props.location.search);
    let token = params.get("token");
    this.setState({ isExecuting: true, showResults: false });

    let url = API_CONFIG.xflowurl + "/components/get-component-report";

    var f = new Date(this.state.from_date);
    var fecha =
      (f.getDate() < 10 ? "0" + f.getDate() : f.getDate()) +
      "/" +
      (f.getMonth() + 1 < 10 ? "0" + (f.getMonth() + 1) : f.getMonth() + 1) +
      "/" +
      (f.getFullYear() + "");
    var from_date = new Date(
      f.getFullYear(),
      f.getMonth(),
      f.getDate(),
      0,
      0,
      0
    );

    let datos = {
      components: this.state.userNameXF,
      from: from_date,
      usuario: this.state.userNameXF,
    };

    let components = this.state.compinfo.data;

    for (let i in components) {
      let component = components[i];
      let header = [];
      for (let j in component.values.options) {
        let obj = component.values.options[j];
        header.push(obj);
      }
      component["header"] = header;
    }
    // console.log("-+--------");
    // console.log(components);

    let filterDefinition = [
      {
        name: "usuario",
        type: "text",
        value: this.state.userNameXF,
      },
      {
        name: "from",
        type: "date",
        value: from_date,
      },
    ];
    /*
    if (this.state.userNameXF != "0") {
      console.log("hhay user");
      filterDefinition.push({
        name: "USERNAME",
        type: "input",
        value: this.state.userNameXF === "0" ? null : this.state.userNameXF,
      });
    }*/

    datos = {
      components: components,
      filterDefinition: filterDefinition,
      filters: {
        from: from_date,
        usuario: this.state.userNameXF, //EJ 13242145
      },
    };

    //console.log(datos);
    await axios({
      url: url,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
      method: "post",
      data: datos,
    })
      .then((response) => response.data)
      .then(async (data) => {
        //console.log(data.results[0]);
        if (data.status) {
          const metodos = [
            {
              text: "EFECTIVO",
              value: "EFECTIVO",
              total: 0,
              monto_total: 0,
              retiro: 0,
              tipo: "E",
            },
            {
              text: "EFECTIVO ME",
              value: "EFECTIVO ME",
              total: 0,
              monto_total: 0,
              retiro: 0,
              tipo: "E",
            },

            {
              text: "TARJETA ATC",
              value: "TARJETA ATC",
              total: 0,
              monto_total: 0,
              retiro: 0,
              tipo: "T",
            },
            {
              text: "TARJETA LINKSER",
              value: "TARJETA LINKSER",
              total: 0,
              monto_total: 0,
              retiro: 0,
              tipo: "T",
            },
            {
              text: "QR ATC",
              value: "QR ATC",
              total: 0,
              monto_total: 0,
              retiro: 0,
              tipo: "C",
            },
            {
              text: "LINEA DE CREDITO IISA",
              value: "LINEA DE CREDITO IISA",
              total: 0,
              monto_total: 0,
              retiro: 0,
              tipo: "C",
            },
            {
              text: "TODOTIX",
              value: "TODOTIX",
              total: 0,
              monto_total: 0,
              retiro: 0,
              tipo: "C",
            },
            {
              text: "CONTRAENTREGA",
              value: "CONTRAENTREGA",
              total: 0,
              monto_total: 0,
              retiro: 0,
              tipo: "C",
            },
            {
              text: "QR BCP",
              value: "QR BCP",
              total: 0,
              monto_total: 0,
              retiro: 0,
              tipo: "C",
            },
          ];

          const metodos_anuladas = [
            {
              text: "EFECTIVO",
              value: "EFECTIVO",
              total: 0,
              monto_total: 0,
              retiro: 0,
              tipo: "E",
            },
            {
              text: "EFECTIVO ME",
              value: "EFECTIVO ME",
              total: 0,
              monto_total: 0,
              retiro: 0,
              tipo: "E",
            },

            {
              text: "TARJETA ATC",
              value: "TARJETA ATC",
              total: 0,
              monto_total: 0,
              retiro: 0,
              tipo: "T",
            },
            {
              text: "TARJETA LINKSER",
              value: "TARJETA LINKSER",
              total: 0,
              monto_total: 0,
              retiro: 0,
              tipo: "T",
            },
            {
              text: "QR ATC",
              value: "QR ATC",
              total: 0,
              monto_total: 0,
              retiro: 0,
              tipo: "C",
            },
            {
              text: "LINEA DE CREDITO IISA",
              value: "LINEA DE CREDITO IISA",
              total: 0,
              monto_total: 0,
              retiro: 0,
              tipo: "C",
            },
            {
              text: "TODOTIX",
              value: "TODOTIX",
              total: 0,
              monto_total: 0,
              retiro: 0,
              tipo: "C",
            },
            {
              text: "CONTRAENTREGA",
              value: "CONTRAENTREGA",
              total: 0,
              monto_total: 0,
              retiro: 0,
              tipo: "C",
            },
            {
              text: "QR BCP",
              value: "QR BCP",
              total: 0,
              monto_total: 0,
              retiro: 0,
              tipo: "C",
            },
          ];

          let orders = data.results[0];
          var facturas_finalizadas = 0;
          var facturas_pendientes = 0;
          var facturas_monto_total = 0;
          var facturas_monto_finalizadas = 0;
          var facturas_monto_pendientes = 0;
          var facturas_anuladas = 0;
          var facturas_monto_anuladas = 0;

          //console.log("orders", orders);
          //console.log("this.state.metodos", this.state.metodos)
          for (let i in orders) {
            let order = orders[i];
            //console.log("order", order.INVOICE_STATUS, order.METODO_PAGO, order.ID_PEDIDO);
            if (order.INVOICE_STATUS === "ANULADA CORRECTAMENTE") {
              facturas_anuladas++;
              facturas_monto_anuladas =
                facturas_monto_anuladas + order.MONTO + order.MONTO2;

              let pos = this.state.metodos_anuladas.findIndex(
                (item) => item.value === order.METODO_PAGO
              );
              if (pos >= 0) {
                //console.log("pos", metodos[pos])
                if (
                  metodos_anuladas[pos].value === "TODOTIX" ||
                  metodos_anuladas[pos].value === "QR BCP"
                ) {
                  metodos_anuladas[pos].retiro =
                    metodos_anuladas[pos].retiro + order.MONTO;
                  // console.log(" ESSSSSSSSSS",metodos[pos].retiro)
                }
                metodos_anuladas[pos].monto_total =
                  metodos_anuladas[pos].monto_total + order.MONTO;
                metodos_anuladas[pos].total = metodos_anuladas[pos].total + 1;
              }
            } else {
              if (order.METODO_PAGO != "CONTRAENTREGA") {
                facturas_finalizadas++;
                facturas_monto_finalizadas =
                  facturas_monto_finalizadas + order.MONTO + order.MONTO2;
              } else {
                console.log("contra", order);
                facturas_pendientes++;
                facturas_monto_pendientes =
                  facturas_monto_pendientes + order.MONTO + order.MONTO2;
              }
              facturas_monto_total =
                facturas_monto_total + order.MONTO + order.MONTO2;
              let pos = this.state.metodos.findIndex(
                (item) => item.value === order.METODO_PAGO
              );
              if (pos >= 0) {
                console.log("pos", metodos[pos])
                if (
                  metodos[pos].value === "TODOTIX" ||
                  metodos[pos].value === "QR BCP"
                ) {
                  metodos[pos].retiro = metodos[pos].retiro + order.MONTO;
                }

                metodos[pos].monto_total =
                  metodos[pos].monto_total + order.MONTO;
                metodos[pos].total = metodos[pos].total + 1;
              }

              if (order.METODODEPAGO2) {
                let pos2 = this.state.metodos.findIndex(
                  (item) => item.value === order.METODODEPAGO2
                );

                if (pos2 >= 0) {
                  console.log("pos2", metodos[pos2], order)
                  if (
                    metodos[pos2].value === "TODOTIX" ||
                    metodos[pos2].value === "QR BCP"
                  ) {
                    metodos[pos2].retiro = metodos[pos2].retiro + order.MONTO2;
                  }
                  metodos[pos2].monto_total =
                    metodos[pos2].monto_total + order.MONTO2;
                  metodos[pos2].total = metodos[pos2].total + 1;
                }
              }
            }
          }

          metodos[0].retiro = parseFloat(this.state.cuad_ret_efec); //EFECTIVO
          metodos[1].retiro = parseFloat(this.state.cuad_ret_usd); //EFECTIVO ME
          metodos[2].retiro = parseFloat(this.state.retiro_tarj_atc); //TARJETA ATC
          metodos[3].retiro = parseFloat(this.state.retiro_tarj_link); //TARJETA LINKSER
          metodos[4].retiro = parseFloat(this.state.conv_ret_qr_red_enlace); //QR ATC
          metodos[5].retiro = parseFloat(this.state.conv_ret_issa); //LINEA DE CREDITO IISA
          metodos[6].retiro = parseFloat(this.state.conv_ret_todotix); //TODOTIX
          metodos[7].retiro = parseFloat(this.state.conv_ret_contraentrega); //CONTRAENTREGA
          metodos[8].retiro = parseFloat(this.state.conv_ret_bcp); //QR BCP

          metodos[0].resultado =
            metodos[0].monto_total +
            parseFloat(this.state.dotacion) -
            (metodos[0].retiro + parseFloat(this.state.cuad_ret_dot));

          metodos[1].resultado =
            metodos[1].monto_total - metodos[1].retiro * this.state.tipo_cambio;
          metodos[2].resultado = metodos[2].monto_total - metodos[2].retiro;
          metodos[3].resultado = metodos[3].monto_total - metodos[3].retiro;
          metodos[4].resultado = metodos[4].monto_total - metodos[4].retiro;
          metodos[5].resultado = metodos[5].monto_total - metodos[5].retiro;
          metodos[6].resultado = metodos[6].monto_total - metodos[6].retiro;
          metodos[7].resultado = metodos[7].monto_total - metodos[7].retiro;
          metodos[8].resultado = metodos[8].monto_total - metodos[8].retiro;

          console.log("metodos", metodos);
          var resultado_final = 0;
          for (let i in metodos) {
            let metodo = metodos[i];
            resultado_final = resultado_final + metodo.resultado;
          }
          resultado_final = Math.round(resultado_final * 100) / 100;
          this.setState({
            ...this.state,
            showResults: true,
            noData: false,
            metodos,
            facturas_finalizadas,
            facturas_pendientes,
            facturas_monto_total,
            facturas_monto_finalizadas,
            facturas_monto_pendientes,
            resultado_final,
            facturas_monto_anuladas,
            facturas_anuladas,
            metodos_anuladas,
          });
          this.setState({ isExecuting: false });

          if (orders && orders.length > 0) {
            const agencia = orders[0].AGENCIA || "";
            await this.handleCierrePersistence(agencia);
          } else {
            toast.warning(
              "No se encontraron órdenes para el usuario/fecha seleccionados — no se guardó el cierre de caja."
            );
          }
        } else {
          this.setState({
            isExecuting: false,
            noData: true,
          });
        }
      });
  };

  // Verifica si ya hay un cierre guardado para este cajero+fecha (componente dashboards
  // CUADRATURA_CIERRE_CHECK). Sin cierre previo: guarda directo. Con cierre previo: muestra
  // el modal de confirmación con los datos ya guardados antes de sobreescribir.
  handleCierrePersistence = async (agencia) => {
    try {
      const existing = await this.checkExistingCierre();
      if (existing) {
        this.setState({
          existingCierre: existing,
          cierreAgencia: agencia,
          showConfirmModal: true,
        });
      } else {
        await this.saveCierre(false, null, agencia);
      }
    } catch (e) {
      console.log("Error validando cierre existente", e);
    }
  };

  checkExistingCierre = async () => {
    let params = new URLSearchParams(this.props.location.search);
    let token = params.get("token");

    const resp = await axios({
      url: API_CONFIG.xflowurl + "/components/get-single-by-code",
      data: { component: "dashboards", code: "CUADRATURA_CIERRE_CHECK" },
      headers: { "Content-Type": "application/json", Authorization: "Bearer " + token },
      method: "post",
    }).then((r) => r.data);

    const compinfo = resp?.data?.DATA;
    if (!compinfo) return null;

    const components = compinfo.data || [];
    components.forEach((c) => {
      c.header = (c.values && c.values.options) || [];
    });

    const f = new Date(this.state.from_date);
    const fechaOnly = new Date(f.getFullYear(), f.getMonth(), f.getDate());

    const datos = {
      components,
      filterDefinition: [
        { name: "CAJERO", type: "text", value: this.state.userNameXF },
        { name: "FECHA", type: "date", value: fechaOnly },
      ],
      filters: { CAJERO: this.state.userNameXF, FECHA: fechaOnly },
    };

    const report = await axios({
      url: API_CONFIG.xflowurl + "/components/get-component-report",
      data: datos,
      headers: { "Content-Type": "application/json", Authorization: "Bearer " + token },
      method: "post",
    }).then((r) => r.data);

    const rows = (report && report.status && report.results && report.results[0]) || [];
    return rows.length > 0 ? rows[0] : null;
  };

  saveCierre = async (isUpdate, existingId, agencia) => {
    let params = new URLSearchParams(this.props.location.search);
    let token = params.get("token");
    this.setState({ savingCierre: true });

    const url =
      API_CONFIG.xflowurl +
      `/customcomponents/${isUpdate ? "update" : "create"}/CUADRATURA_MEDIOS_COBRO`;

    const f = new Date(this.state.from_date);
    const fechaOnly = new Date(f.getFullYear(), f.getMonth(), f.getDate());

    const payload = {
      CAJERO: this.state.userNameXF,
      FECHA: fechaOnly,
      AGENCIA: agencia || this.state.cierreAgencia || "",
      DOTACION: parseFloat(this.state.dotacion) || 0,
      TIPO_CAMBIO: parseFloat(this.state.tipo_cambio) || 0,
      CUAD_RET_DOT: parseFloat(this.state.cuad_ret_dot) || 0,
      CUAD_RET_EFEC: parseFloat(this.state.cuad_ret_efec) || 0,
      CUAD_RET_USD: parseFloat(this.state.cuad_ret_usd) || 0,
      RETIRO_TARJ_ATC: parseFloat(this.state.retiro_tarj_atc) || 0,
      RETIRO_TARJ_LINK: parseFloat(this.state.retiro_tarj_link) || 0,
      CONV_RET_QR_RED_ENLACE: parseFloat(this.state.conv_ret_qr_red_enlace) || 0,
      CONV_RET_ISSA: parseFloat(this.state.conv_ret_issa) || 0,
      CONV_RET_CONTRAENTREGA: parseFloat(this.state.conv_ret_contraentrega) || 0,
      CONV_RET_TODOTIX: parseFloat(this.state.conv_ret_todotix) || 0,
      CONV_RET_BCP: parseFloat(this.state.conv_ret_bcp) || 0,
    };
    if (isUpdate && existingId) {
      payload.id = existingId;
    }

    try {
      const resp = await axios({
        url,
        method: "put",
        data: payload,
        headers: { "Content-Type": "application/json", Authorization: "Bearer " + token },
      }).then((r) => r.data);

      if (resp && resp.status) {
        toast.success(
          isUpdate ? "Cierre actualizado correctamente" : "Cierre guardado correctamente",
          { closeButton: true }
        );
      } else {
        toast.error("No se pudo guardar el cierre: " + (resp?.message || ""), {
          closeButton: true,
        });
      }
    } catch (e) {
      console.log("Error guardando cierre", e);
      toast.error("Error guardando el cierre de caja", { closeButton: true });
    } finally {
      this.setState({ savingCierre: false, showConfirmModal: false, existingCierre: null });
    }
  };

  generatePDF = () => {
    const doc = new jsPDF({ unit: "pt", format: "letter" });
    const pageW = doc.internal.pageSize.getWidth();
    const ml = 40;
    let y = 0;

    // Header
    doc.setFillColor(30, 64, 175);
    doc.rect(0, 0, pageW, 48, "F");
    doc.setFont("helvetica", "bold");
    doc.setFontSize(12);
    doc.setTextColor(255, 255, 255);
    doc.text("COMPROBANTE CIERRE DE USUARIO", pageW / 2, 25, { align: "center" });
    doc.setFontSize(8);
    doc.setFont("helvetica", "normal");
    doc.text(`Generado: ${this.state.fecha}`, pageW / 2, 39, { align: "center" });
    y = 58;

    const sectionHeader = (title) => {
      doc.setFillColor(219, 234, 254);
      doc.rect(ml, y, pageW - 2 * ml, 14, "F");
      doc.setFontSize(8.5);
      doc.setFont("helvetica", "bold");
      doc.setTextColor(30, 64, 175);
      doc.text(title, ml + 7, y + 10);
      doc.setTextColor(30, 30, 30);
      y += 16;
    };

    // Info general (2 filas x 2 pares)
    autoTable(doc, {
      startY: y,
      body: [
        ["Fecha Seleccionada", new Date(this.state.from_date).toLocaleDateString("es-BO", { day: "2-digit", month: "2-digit", year: "numeric" }), "Fecha Actual", this.state.fecha],
        ["Usuario", this.state.userNameXF, "Dotación", parseFloat(this.state.dotacion).toFixed(2)],
      ],
      theme: "grid",
      styles: { fontSize: 8.5, cellPadding: 3 },
      columnStyles: { 0: { fontStyle: "bold", fillColor: [248, 250, 252], cellWidth: 100 }, 2: { fontStyle: "bold", fillColor: [248, 250, 252], cellWidth: 100 } },
      margin: { left: ml, right: ml },
    });
    y = doc.lastAutoTable.finalY + 5;

    // Comprobantes emitidos - Ventas
    sectionHeader("COMPROBANTES EMITIDOS - VENTAS");
    autoTable(doc, {
      startY: y,
      head: [["Concepto", "Monto Bs.", "Cant."]],
      body: [
        ["FACTURAS - FINALIZADAS", this.state.facturas_monto_finalizadas.toFixed(2), this.state.facturas_finalizadas],
        ["FACTURAS - PENDIENTES DE COBRO", this.state.facturas_monto_pendientes.toFixed(2), this.state.facturas_pendientes],
        ["TOTAL", this.state.facturas_monto_total.toFixed(2), this.state.facturas_finalizadas + this.state.facturas_pendientes],
      ],
      theme: "striped",
      headStyles: { fillColor: [30, 64, 175], textColor: 255, fontSize: 8.5 },
      bodyStyles: { fontSize: 8.5, cellPadding: 3 },
      columnStyles: { 1: { halign: "right" }, 2: { halign: "right", cellWidth: 60 } },
      margin: { left: ml, right: ml },
    });
    y = doc.lastAutoTable.finalY + 5;

    // Comprobantes por método
    sectionHeader("COMPROBANTES EMITIDOS POR MÉTODO");
    const metRows = this.state.metodos.filter((m) => m.total > 0).map((m) => [m.value, m.monto_total.toFixed(2), m.total]);
    metRows.push(["TOTAL", this.state.facturas_monto_total.toFixed(2), this.state.facturas_finalizadas + this.state.facturas_pendientes]);
    autoTable(doc, {
      startY: y,
      head: [["Método de Pago", "Monto Bs.", "Cant."]],
      body: metRows,
      theme: "striped",
      headStyles: { fillColor: [30, 64, 175], textColor: 255, fontSize: 8.5 },
      bodyStyles: { fontSize: 8.5, cellPadding: 3 },
      columnStyles: { 1: { halign: "right" }, 2: { halign: "right", cellWidth: 60 } },
      margin: { left: ml, right: ml },
    });
    y = doc.lastAutoTable.finalY + 5;

    // Ventas nulas
    const nulaRows = this.state.metodos_anuladas.filter((m) => m.total > 0).map((m) => [m.value, typeof m.monto_total.toFixed === "function" ? m.monto_total.toFixed(2) : m.monto_total, m.total]);
    if (nulaRows.length > 0) {
      sectionHeader("VENTAS NULAS");
      nulaRows.push(["TOTAL", this.state.facturas_monto_anuladas.toFixed(2), this.state.facturas_anuladas]);
      autoTable(doc, {
        startY: y,
        head: [["Método de Pago", "Monto Bs.", "Cant."]],
        body: nulaRows,
        theme: "striped",
headStyles: { fillColor: [220, 38, 38], textColor: 255, fontSize: 8.5 },
        bodyStyles: { fontSize: 8.5, cellPadding: 3 },
        columnStyles: { 1: { halign: "right" }, 2: { halign: "right", cellWidth: 60 } },
        margin: { left: ml, right: ml },
      });
      y = doc.lastAutoTable.finalY + 5;
    }

    // Cuadratura
    sectionHeader("CUADRATURA");
    const cuadRows = [];
    const m = this.state.metodos;
    if (m[0].monto_total > 0 || m[0].retiro > 0 || parseFloat(this.state.cuad_ret_dot) > 0) {
      cuadRows.push(
        ["TOTAL EFECTIVO", (m[0].monto_total + parseFloat(this.state.dotacion)).toFixed(2), m[0].total],
        ["RETIRO DOTACIÓN", `-${parseFloat(this.state.cuad_ret_dot).toFixed(2)}`, ""],
        ["RETIRO EFECTIVO", `-${parseFloat(this.state.cuad_ret_efec).toFixed(2)}`, ""],
        ["RESULTADO EFECTIVO", (m[0].monto_total + parseFloat(this.state.dotacion) - (parseFloat(this.state.cuad_ret_dot) + parseFloat(this.state.cuad_ret_efec))).toFixed(2), ""],
      );
    }
    if (m[1].monto_total > 0 || m[1].retiro > 0) {
      cuadRows.push(
        ["TOTAL EFECTIVO ME", m[1].monto_total.toFixed(2), m[1].total],
        [`RETIRO USD (T/C ${this.state.tipo_cambio})`, `-${(parseFloat(this.state.cuad_ret_usd) * this.state.tipo_cambio).toFixed(2)}`, ""],
        ["RESULTADO EFECTIVO ME", (m[1].monto_total - parseFloat(this.state.cuad_ret_usd) * this.state.tipo_cambio).toFixed(2), ""],
      );
    }
    this.state.metodos.forEach((met) => {
      if ((met.total > 0 || met.retiro > 0) && met.tipo === "T") {
        cuadRows.push(
          [`TOTAL ${met.value}`, parseFloat(met.monto_total).toFixed(2), met.total],
          [`RETIRO ${met.value}`, `-${parseFloat(met.retiro).toFixed(2)}`, ""],
          [`RESULTADO ${met.value}`, parseFloat(met.monto_total - met.retiro).toFixed(2), ""],
        );
      }
    });
    this.state.metodos.forEach((met) => {
      if ((met.total > 0 || met.retiro > 0) && met.tipo === "C") {
        cuadRows.push(
          [`TOTAL ${met.value}`, parseFloat(met.monto_total).toFixed(2), met.total],
          [`RETIRO ${met.value}`, `-${parseFloat(met.retiro).toFixed(2)}`, ""],
          [`RESULTADO ${met.value}`, parseFloat(met.monto_total - met.retiro).toFixed(2), ""],
        );
      }
    });
    autoTable(doc, {
      startY: y,
      head: [["Concepto", "Monto Bs.", "Cant."]],
      body: cuadRows,
      theme: "striped",
      headStyles: { fillColor: [30, 64, 175], textColor: 255, fontSize: 8.5 },
      bodyStyles: { fontSize: 8.5, cellPadding: 2 },
      columnStyles: { 1: { halign: "right" }, 2: { halign: "right", cellWidth: 60 } },
      margin: { left: ml, right: ml },
    });
    y = doc.lastAutoTable.finalY + 5;

    // Resultado final
    const rf = this.state.resultado_final;
    autoTable(doc, {
      startY: y,
      body: [
        ["SOBRANTE", rf < 0 ? rf.toFixed(2) : "0.00"],
        ["FALTANTE", rf > 0 ? rf.toFixed(2) : "0.00"],
        ["FACTURAS PENDIENTES DE COBRO", this.state.facturas_monto_pendientes.toFixed(2)],
      ],
      theme: "grid",
      styles: { fontSize: 8.5, cellPadding: 3, fontStyle: "bold" },
      columnStyles: { 0: { fillColor: [248, 250, 252] }, 1: { halign: "right" } },
      margin: { left: ml, right: ml },
    });
    y = doc.lastAutoTable.finalY + 8;

    // Observaciones
    doc.setFont("helvetica", "bold");
    doc.setFontSize(8.5);
    doc.setTextColor(30, 30, 30);
    doc.text("Observaciones:", ml, y);
    y += 4;
    doc.setDrawColor(180, 180, 180);
    doc.roundedRect(ml, y, pageW - 2 * ml, 32, 3, 3, "S");
    y += 44;

    if (y + 48 > doc.internal.pageSize.getHeight() - 40) {
      doc.addPage();
      y = 40;
    }

    // Firmas
    const signW = (pageW - 2 * ml - 24) / 2;
    doc.setDrawColor(150, 150, 150);
    doc.rect(ml, y, signW, 34, "S");
    doc.rect(ml + signW + 24, y, signW, 34, "S");
    doc.setFont("helvetica", "normal");
    doc.setFontSize(7.5);
    doc.setTextColor(100, 100, 100);
    doc.text("Firma Usuario", ml + signW / 2, y + 46, { align: "center" });
    doc.text("Firma Supervisor", ml + signW + 24 + signW / 2, y + 46, { align: "center" });

    doc.save(`Arqueo_${this.state.userNameXF}.pdf`);
  };

  LoadSections = async (userType) => {
    let params = new URLSearchParams(this.props.location.search);
    let token = params.get("token");
    this.setState({ isExecuting: true });

    console.log("process.env.REACT_APP_DEV", process.env.REACT_APP_DEV)
    await axios({
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
      url: API_CONFIG.xflowurl + "/engine-users/decrypt-token",
      //url : "http://localhost:4042/api/v1"+"/engine-users/decrypt-token",
      method: "post",
    })
      .then((response) => response.data)
      .then((data) => {
        console.log("data", data);
        if (data.status) {
          const isAdmin = data.token.USERGROUP === "ADMINECOM";
          this.setState({
            ...this.state,
            userNameXF: process.env.REACT_APP_DEV === "YES" ? "3422639" : data.token.USERNAME,
            username: data.token.USERNAME,
            organization: data.token.ORGANIZATIONCODE,
            isAdmin: isAdmin,
          });
        }
      });

    await axios({
      url: API_CONFIG.xflowurl + "/components/get-single-by-code",
      data: { component: "dashboards", code: "CIERRE_USUARIO" },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
      method: "post",
    })
      .then((response) => response.data)
      .then((data) => {
        let compinfo = data.data.DATA;
        this.setState({ compinfo: compinfo });
      });

    let url = API_CONFIG.xflowurl + "/users/get-all";

    await axios({
      url: url,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
      method: "post",
    })
      .then((response) => response.data)
      .then((data) => {
        if (data.result.length > 0) {
          var objSections = [];

          objSections.push({
            text: "TODOS",
            value: "0",
            checked: true,
          });

          for (var key in data.result) {
            let dataObject = {
              value: data.result[key].USERNAME,
              text: data.result[key].USERNAME,
            };
            objSections.push(dataObject);
          }

          this.setState({ options: objSections });

          this.setState({ isExecuting: false });
        } else {
          this.setState({ isExecuting: false });
        }
      });
  };

  selectHandlerT = (event) => {
    if (event[0]) {
      this.setState({ ...this.state, userType: event[0], userNameXF: "" });
      this.LoadSections(event[0]);
    }
  };

  selectHandler = (event) => {
    this.setState({ ...this.state, userNameXF: event[0] });
  };

  changeHandler = (e) => {
    const { name, value } = e.target;

    // 1. Reemplazamos comas por puntos (opcional, por si el usuario usa teclado numérico con coma)
    let val = value.replace(',', '.');

    // 2. Regex: Permite números y solo el primer punto que encuentre
    // Explicación: 
    // ^\d* -> Empieza con cero o más dígitos
    // \.?          -> Puede tener un punto opcional
    // \d{0,2}$     -> Puede tener hasta 2 decimales (ajusta el 2 si quieres más)
    const regex = /^\d*\.?\d{0,2}$/;

    if (regex.test(val) || val === "") {
      this.setState({
        [name]: val
      });
    } else {
      this.setState({
        [name]: 0
      });
    }
  };

  /*
  changeHandler = (event) => {
    //console.log(event.target.value);
    this.setState({ ...this.state, [event.target.name]: event.target.value });
  };
  */
  getPickerValueTo = (value) => {
    this.setState({ to_date: value });
  };

  // XDatePicker (Components/XForm.js) manda el valor como string "DD/MM/YYYY"
  // (dateFormat: "d/m/Y" de flatpickr), no como Date. `new Date("24/07/2026")`
  // no lo parsea de forma confiable (V8 lo lee como MM/DD y descarta por "24" de
  // mes inválido) -> Invalid Date -> se serializa como null al backend, rompiendo
  // generar/guardar. Acá se parsea explícito el DD/MM/YYYY antes de guardarlo.
  getPickerValueFrom = (value) => {
    if (value instanceof Date && !isNaN(value)) {
      this.setState({ from_date: value });
      return;
    }
    const m = String(value || "").match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
    if (m) {
      this.setState({ from_date: new Date(Number(m[3]), Number(m[2]) - 1, Number(m[1])) });
      return;
    }
    const parsed = new Date(value);
    if (!isNaN(parsed)) {
      this.setState({ from_date: parsed });
    }
    // si no se pudo parsear nada, se deja from_date como estaba (no se pisa con basura)
  };

  render() {
    return (
      <MDBContainer
        fluid
        className="justify-content-left text-left xext-page xext-report-arqueo4"
        style={{ marginLeft: "0" }}
      >
        <Loader idLoading={this.state.isExecuting} />

        {/* Filtros card */}
        <div className="xext-report-card">
          <div className="xext-report-card-title"><MDBIcon icon="user-circle" /> Datos del cierre</div>
          <MDBRow>
            <MDBCol sm="12" md="6" lg="4" className="text-left">
              <XInput
                id="userNameXF" key="userNameXF" name="userNameXF"
                value={this.state.userNameXF} readonly={true} size="sm" label="Usuario"
              />
            </MDBCol>
            <MDBCol sm="12" md="6" lg="4" className="text-left">
              <div className="xext-date-label">Fecha de cierre</div>
              <XDatePicker
                key="from" name="from" id="from" format="DD/MM/YYYY"
                value={this.state.from_date} cancelLabel="Cancelar" getValue={this.getPickerValueFrom}
                disabled={!this.state.isAdmin}
              />
            </MDBCol>
            <MDBCol sm="12" md="6" lg="4" className="text-left">
              <XInput
                id="dotacion" key="dotacion" name="dotacion"
                value={this.state.dotacion} onChange={this.changeHandler} size="sm" label="Dotación"
              />
            </MDBCol>
          </MDBRow>
          <MDBRow>
            <MDBCol sm="12" md="6" lg="4" className="text-left">
              <XInput
                id="tipo_cambio" key="tipo_cambio" name="tipo_cambio"
                value={this.state.tipo_cambio} onChange={this.changeHandler} size="sm" label="Tipo de cambio (USD)"
              />
            </MDBCol>
          </MDBRow>
        </div>

        <div className="xext-report-card">
          <div className="xext-report-card-title"><MDBIcon icon="money-bill-wave" /> Retiros en efectivo</div>
          <MDBRow>
            <MDBCol sm="12" md="6" lg="4" className="text-left">
              <XInput id="cuad_ret_dot" key="cuad_ret_dot" name="cuad_ret_dot"
                value={this.state.cuad_ret_dot} onChange={this.changeHandler} size="sm" label="Retiro dotación" />
            </MDBCol>
            <MDBCol sm="12" md="6" lg="4" className="text-left">
              <XInput id="cuad_ret_efec" key="cuad_ret_efec" name="cuad_ret_efec"
                value={this.state.cuad_ret_efec} onChange={this.changeHandler} size="sm" label="Retiro efectivo" />
            </MDBCol>
            <MDBCol sm="12" md="6" lg="4" className="text-left">
              <XInput id="cuad_ret_usd" key="cuad_ret_usd" name="cuad_ret_usd"
                value={this.state.cuad_ret_usd} onChange={this.changeHandler} size="sm"
                label={"Retiro USD (T/C " + this.state.tipo_cambio + ")"} />
            </MDBCol>
          </MDBRow>
          <MDBRow>
            <MDBCol sm="12" md="6" lg="4" className="text-left">
              <XInput id="retiro_tarj_atc" key="retiro_tarj_atc" name="retiro_tarj_atc"
                value={this.state.retiro_tarj_atc} onChange={this.changeHandler} size="sm" label="Retiro tarj. ATC" />
            </MDBCol>
            <MDBCol sm="12" md="6" lg="4" className="text-left">
              <XInput id="retiro_tarj_link" key="retiro_tarj_link" name="retiro_tarj_link"
                value={this.state.retiro_tarj_link} onChange={this.changeHandler} size="sm" label="Retiro tarj. Linkser" />
            </MDBCol>
          </MDBRow>
        </div>

        <div className="xext-report-card">
          <div className="xext-report-card-title"><MDBIcon icon="handshake" /> Convenios</div>
          <MDBRow>
            <MDBCol sm="12" md="6" lg="4" className="text-left">
              <XInput id="conv_ret_qr_red_enlace" key="conv_ret_qr_red_enlace" name="conv_ret_qr_red_enlace"
                value={this.state.conv_ret_qr_red_enlace} onChange={this.changeHandler} size="sm" label="Retiro QR ATC" />
            </MDBCol>
            <MDBCol sm="12" md="6" lg="4" className="text-left">
              <XInput id="conv_ret_issa" key="conv_ret_issa" name="conv_ret_issa"
                value={this.state.conv_ret_issa} onChange={this.changeHandler} size="sm" label="Línea de Crédito IISA" />
            </MDBCol>
            <MDBCol sm="12" md="6" lg="4" className="text-left">
              <XInput id="conv_ret_contraentrega" key="conv_ret_contraentrega" name="conv_ret_contraentrega"
                value={this.state.conv_ret_contraentrega} onChange={this.changeHandler} size="sm" label="Retiro Contraentrega" />
            </MDBCol>
          </MDBRow>
          <MDBRow>
            <MDBCol sm="12" md="6" lg="4" className="text-left">
              <XInput id="conv_ret_todotix" key="conv_ret_todotix" name="conv_ret_todotix"
                value={this.state.conv_ret_todotix} onChange={this.changeHandler} size="sm" label="Retiro TODOTIX" />
            </MDBCol>
            <MDBCol sm="12" md="6" lg="4" className="text-left">
              <XInput id="conv_ret_bcp" key="conv_ret_bcp" name="conv_ret_bcp"
                value={this.state.conv_ret_bcp} onChange={this.changeHandler} size="sm" label="Retiro QR BCP" />
            </MDBCol>
            <MDBCol sm="12" md="6" lg="4" className="text-left" style={{ display: "flex", alignItems: "flex-end", paddingBottom: "6px" }}>
              <XBtn href="#reportResult" key="find" onClick={this.generateReport}
                size="sm" color="primary" className="text-capitalize xext-report-primary-btn">
                <MDBIcon icon="chart-bar" /> Generar Reporte
              </XBtn>
            </MDBCol>
          </MDBRow>
        </div>

        {this.state.noData && (
          <div className="xext-inline-alert xext-inline-alert--warning">
            <MDBIcon icon="exclamation-triangle" className="xext-inline-alert-icon" />
            No se encontraron datos para el periodo seleccionado
          </div>
        )}
        {this.state.showResults ? (
          <>
            <div className="xext-report-pdf-bar">
              <XBtn size="sm" color="danger" onClick={this.generatePDF}>
                <MDBIcon icon="file-pdf" /> Exportar PDF
              </XBtn>
            </div>
            <MDBRow>
              <MDBCol sm="12" md="12" lg="12" xl="12">
                <div className="xext-report-preview-wrap">
                  {/* Header del comprobante */}
                  <div style={{ background: "#1e40af", borderRadius: "10px 10px 0 0", color: "#fff", marginBottom: "16px", padding: "14px 20px" }}>
                    <div style={{ fontSize: "0.72rem", fontWeight: 600, letterSpacing: "0.1em", opacity: 0.75, textTransform: "uppercase" }}>Comprobante</div>
                    <div style={{ fontSize: "1.05rem", fontWeight: 700, marginTop: "2px" }}>Cierre de Usuario</div>
                    <div style={{ fontSize: "0.78rem", marginTop: "6px", opacity: 0.85 }}>
                      <span style={{ marginRight: "18px" }}><strong>Usuario:</strong> {this.state.userNameXF}</span>
                      <span><strong>Generado:</strong> {this.state.fecha}</span>
                    </div>
                  </div>

                  {/* Info general */}
                  <table className="xext-report-table" style={{ marginBottom: "16px" }}>
                    <tbody>
                      <tr>
                        <td className="xext-rt-label">Fecha de cierre</td>
                        <td>{new Date(this.state.from_date).toLocaleDateString("es-BO", { day: "2-digit", month: "2-digit", year: "numeric" })}</td>
                        <td className="xext-rt-label">Fecha actual</td>
                        <td>{this.state.fecha}</td>
                      </tr>
                      <tr>
                        <td className="xext-rt-label">Usuario</td>
                        <td><strong>{this.state.userNameXF}</strong></td>
                        <td className="xext-rt-label">Dotación</td>
                        <td><strong>{parseFloat(this.state.dotacion).toFixed(2)} Bs.</strong></td>
                      </tr>
                    </tbody>
                  </table>

                  {/* Comprobantes emitidos - Ventas */}
                  <table className="xext-report-table" style={{ marginBottom: "16px" }}>
                    <thead>
                      <tr><th colSpan="3">Comprobantes Emitidos — Ventas</th></tr>
                      <tr style={{ background: "#eff6ff" }}>
                        <th style={{ background: "#eff6ff", color: "#1e40af", fontWeight: 700 }}>Concepto</th>
                        <th style={{ background: "#eff6ff", color: "#1e40af", fontWeight: 700, textAlign: "right" }}>Monto Bs.</th>
                        <th style={{ background: "#eff6ff", color: "#1e40af", fontWeight: 700, textAlign: "right", width: "70px" }}>Cant.</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td className="xext-rt-label">Facturas finalizadas</td>
                        <td className="text-right">{this.state.facturas_monto_finalizadas.toFixed(2)}</td>
                        <td className="text-right">{this.state.facturas_finalizadas}</td>
                      </tr>
                      <tr>
                        <td className="xext-rt-label">Facturas pendientes de cobro</td>
                        <td className="text-right">{this.state.facturas_monto_pendientes.toFixed(2)}</td>
                        <td className="text-right">{this.state.facturas_pendientes}</td>
                      </tr>
                      <tr className="xext-rt-total">
                        <td>Total</td>
                        <td className="text-right">{this.state.facturas_monto_total.toFixed(2)}</td>
                        <td className="text-right">{this.state.facturas_finalizadas + this.state.facturas_pendientes}</td>
                      </tr>
                    </tbody>
                  </table>

                  {/* Comprobantes por método */}
                  <table className="xext-report-table" style={{ marginBottom: "16px" }}>
                    <thead>
                      <tr><th colSpan="3">Comprobantes por Método de Pago</th></tr>
                      <tr style={{ background: "#eff6ff" }}>
                        <th style={{ background: "#eff6ff", color: "#1e40af", fontWeight: 700 }}>Método</th>
                        <th style={{ background: "#eff6ff", color: "#1e40af", fontWeight: 700, textAlign: "right" }}>Monto Bs.</th>
                        <th style={{ background: "#eff6ff", color: "#1e40af", fontWeight: 700, textAlign: "right", width: "70px" }}>Cant.</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.metodos.filter((m) => m.total > 0).map((m, i) => (
                        <tr key={i}>
                          <td className="xext-rt-label">{m.value}</td>
                          <td className="text-right">{m.monto_total.toFixed(2)}</td>
                          <td className="text-right">{m.total}</td>
                        </tr>
                      ))}
                      <tr className="xext-rt-total">
                        <td>Total</td>
                        <td className="text-right">{this.state.facturas_monto_total.toFixed(2)}</td>
                        <td className="text-right">{this.state.facturas_finalizadas + this.state.facturas_pendientes}</td>
                      </tr>
                    </tbody>
                  </table>

                  {/* Ventas nulas */}
                  {this.state.metodos_anuladas.some((m) => m.total > 0) && (
                    <table className="xext-report-table" style={{ marginBottom: "16px" }}>
                      <thead>
                        <tr><th colSpan="3" style={{ background: "#dc2626" }}>Ventas Nulas</th></tr>
                        <tr style={{ background: "#fef2f2" }}>
                          <th style={{ background: "#fef2f2", color: "#dc2626", fontWeight: 700 }}>Método</th>
                          <th style={{ background: "#fef2f2", color: "#dc2626", fontWeight: 700, textAlign: "right" }}>Monto Bs.</th>
                          <th style={{ background: "#fef2f2", color: "#dc2626", fontWeight: 700, textAlign: "right", width: "70px" }}>Cant.</th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.metodos_anuladas.filter((m) => m.total > 0).map((m, i) => (
                          <tr key={i}>
                            <td className="xext-rt-label">{m.value}</td>
                            <td className="text-right">{typeof m.monto_total.toFixed === "function" ? m.monto_total.toFixed(2) : m.monto_total}</td>
                            <td className="text-right">{m.total}</td>
                          </tr>
                        ))}
                        <tr className="xext-rt-total">
                          <td>Total nulas</td>
                          <td className="text-right">{this.state.facturas_monto_anuladas.toFixed(2)}</td>
                          <td className="text-right">{this.state.facturas_anuladas}</td>
                        </tr>
                      </tbody>
                    </table>
                  )}

                  {/* Cuadratura */}
                  <table className="xext-report-table" style={{ marginBottom: "16px" }}>
                    <thead>
                      <tr><th colSpan="3">Cuadratura</th></tr>
                      <tr style={{ background: "#eff6ff" }}>
                        <th style={{ background: "#eff6ff", color: "#1e40af", fontWeight: 700 }}>Concepto</th>
                        <th style={{ background: "#eff6ff", color: "#1e40af", fontWeight: 700, textAlign: "right" }}>Monto Bs.</th>
                        <th style={{ background: "#eff6ff", color: "#1e40af", fontWeight: 700, textAlign: "right", width: "70px" }}>Cant.</th>
                      </tr>
                    </thead>
                    <tbody>
                      {(this.state.metodos[0].monto_total > 0 || this.state.metodos[0].retiro > 0 || parseFloat(this.state.cuad_ret_dot) > 0) && (
                        <>
                          <tr><td colSpan="3" className="xext-rt-section" style={{ fontSize: "0.72rem" }}>Efectivo</td></tr>
                          <tr>
                            <td className="xext-rt-label">Total efectivo</td>
                            <td className="text-right">{(this.state.metodos[0].monto_total + parseFloat(this.state.dotacion)).toFixed(2)}</td>
                            <td className="text-right">{this.state.metodos[0].total}</td>
                          </tr>
                          <tr>
                            <td className="xext-rt-label">Retiro dotación</td>
                            <td className="text-right" style={{ color: "#ef4444" }}>-{parseFloat(this.state.cuad_ret_dot).toFixed(2)}</td>
                            <td className="text-right">—</td>
                          </tr>
                          <tr>
                            <td className="xext-rt-label">Retiro efectivo</td>
                            <td className="text-right" style={{ color: "#ef4444" }}>-{parseFloat(this.state.cuad_ret_efec).toFixed(2)}</td>
                            <td className="text-right">—</td>
                          </tr>
                          <tr className="xext-rt-total">
                            <td>Resultado efectivo</td>
                            <td className="text-right">{(this.state.metodos[0].monto_total + parseFloat(this.state.dotacion) - (parseFloat(this.state.cuad_ret_dot) + parseFloat(this.state.cuad_ret_efec))).toFixed(2)}</td>
                            <td className="text-right">—</td>
                          </tr>
                        </>
                      )}
                      {(this.state.metodos[1].monto_total > 0 || this.state.metodos[1].retiro > 0) && (
                        <>
                          <tr><td colSpan="3" className="xext-rt-section" style={{ fontSize: "0.72rem" }}>Efectivo ME</td></tr>
                          <tr>
                            <td className="xext-rt-label">Total EFECTIVO ME</td>
                            <td className="text-right">{this.state.metodos[1].monto_total.toFixed(2)}</td>
                            <td className="text-right">{this.state.metodos[1].total}</td>
                          </tr>
                          <tr>
                            <td className="xext-rt-label">Retiro USD (T/C {this.state.tipo_cambio})</td>
                            <td className="text-right" style={{ color: "#ef4444" }}>-{(parseFloat(this.state.cuad_ret_usd) * this.state.tipo_cambio).toFixed(2)}</td>
                            <td className="text-right">—</td>
                          </tr>
                          <tr className="xext-rt-total">
                            <td>Resultado EFECTIVO ME</td>
                            <td className="text-right">{(this.state.metodos[1].monto_total - parseFloat(this.state.cuad_ret_usd) * this.state.tipo_cambio).toFixed(2)}</td>
                            <td className="text-right">—</td>
                          </tr>
                        </>
                      )}
                      {this.state.metodos.filter((m) => (m.total > 0 || m.retiro > 0) && m.tipo === "T").map((m, i) => (
                        <>
                          {i === 0 && <tr key="t-h"><td colSpan="3" className="xext-rt-section" style={{ fontSize: "0.72rem" }}>Tarjetas</td></tr>}
                          <tr key={`t-${i}-tot`}>
                            <td className="xext-rt-label">Total {m.value}</td>
                            <td className="text-right">{parseFloat(m.monto_total).toFixed(2)}</td>
                            <td className="text-right">{m.total}</td>
                          </tr>
                          <tr key={`t-${i}-ret`}>
                            <td className="xext-rt-label">Retiro {m.value}</td>
                            <td className="text-right" style={{ color: "#ef4444" }}>-{parseFloat(m.retiro).toFixed(2)}</td>
                            <td className="text-right">—</td>
                          </tr>
                          <tr key={`t-${i}-res`} className="xext-rt-total">
                            <td>Resultado {m.value}</td>
                            <td className="text-right">{parseFloat(m.monto_total - m.retiro).toFixed(2)}</td>
                            <td className="text-right">—</td>
                          </tr>
                        </>
                      ))}
                      {this.state.metodos.filter((m) => (m.total > 0 || m.retiro > 0) && m.tipo === "C").map((m, i) => (
                        <>
                          {i === 0 && <tr key="c-h"><td colSpan="3" className="xext-rt-section" style={{ fontSize: "0.72rem" }}>Convenios</td></tr>}
                          <tr key={`c-${i}-tot`}>
                            <td className="xext-rt-label">Total {m.value}</td>
                            <td className="text-right">{parseFloat(m.monto_total).toFixed(2)}</td>
                            <td className="text-right">{m.total}</td>
                          </tr>
                          <tr key={`c-${i}-ret`}>
                            <td className="xext-rt-label">Retiro {m.value}</td>
                            <td className="text-right" style={{ color: "#ef4444" }}>-{parseFloat(m.retiro).toFixed(2)}</td>
                            <td className="text-right">—</td>
                          </tr>
                          <tr key={`c-${i}-res`} className="xext-rt-total">
                            <td>Resultado {m.value}</td>
                            <td className="text-right">{parseFloat(m.monto_total - m.retiro).toFixed(2)}</td>
                            <td className="text-right">—</td>
                          </tr>
                        </>
                      ))}
                    </tbody>
                  </table>

                  {/* Resultado final */}
                  <table className="xext-report-table" style={{ marginBottom: "20px" }}>
                    <tbody>
                      <tr style={{ background: this.state.resultado_final <= 0 ? "#f0fdf4" : "#fef2f2" }}>
                        <td style={{ fontWeight: 700, color: this.state.resultado_final <= 0 ? "#166534" : "#991b1b", fontSize: "0.9rem" }}>
                          {this.state.resultado_final <= 0 ? "SOBRANTE" : "FALTANTE"}
                        </td>
                        <td className="text-right" style={{ fontWeight: 700, fontSize: "1rem", color: this.state.resultado_final <= 0 ? "#166534" : "#991b1b" }}>
                          {Math.abs(this.state.resultado_final).toFixed(2)} Bs.
                        </td>
                        <td className="text-right" style={{ width: "70px" }}>—</td>
                      </tr>
                      <tr>
                        <td className="xext-rt-label">Facturas pendientes de cobro</td>
                        <td className="text-right">{this.state.facturas_monto_pendientes.toFixed(2)}</td>
                        <td className="text-right">—</td>
                      </tr>
                    </tbody>
                  </table>

                  {/* Observaciones + firmas */}
                  <div style={{ border: "1px solid #e2e8f0", borderRadius: "8px", marginBottom: "16px", minHeight: "70px", padding: "10px 14px" }}>
                    <div style={{ color: "#64748b", fontSize: "0.75rem", fontWeight: 700, marginBottom: "4px", textTransform: "uppercase" }}>Observaciones</div>
                  </div>
                  <div style={{ display: "flex", gap: "16px", marginTop: "8px" }}>
                    <div style={{ border: "1px solid #e2e8f0", borderRadius: "8px", flex: 1, minHeight: "60px", padding: "10px 14px", textAlign: "center" }}>
                      <div style={{ color: "#64748b", fontSize: "0.72rem", marginTop: "30px" }}>Firma Usuario</div>
                    </div>
                    <div style={{ border: "1px solid #e2e8f0", borderRadius: "8px", flex: 1, minHeight: "60px", padding: "10px 14px", textAlign: "center" }}>
                      <div style={{ color: "#64748b", fontSize: "0.72rem", marginTop: "30px" }}>Firma Supervisor</div>
                    </div>
                  </div>
                </div>
              </MDBCol>
            </MDBRow>
          </>
        ) : (
          ""
        )}

        <MDBModal
          isOpen={this.state.showConfirmModal}
          toggle={() => this.setState({ showConfirmModal: false, existingCierre: null })}
          size="lg"
        >
          <MDBModalHeader toggle={() => this.setState({ showConfirmModal: false, existingCierre: null })}>
            Ya existe un cierre guardado para {this.state.userNameXF}
          </MDBModalHeader>
          <MDBModalBody>
            {this.state.existingCierre && (
              <>
                <p>
                  <strong>Fecha del registro guardado: </strong>
                  {formatBackendDate(
                    this.state.existingCierre.UPDATE_DATE || this.state.existingCierre.INSERT_DATE
                  )}
                </p>
                <table className="xext-report-table">
                  <tbody>
                    {CIERRE_MODAL_FIELDS.map((f) => (
                      <tr key={f.field}>
                        <td className="xext-rt-label">{f.label}</td>
                        <td className="text-right">
                          {Number(this.state.existingCierre[f.field] || 0).toFixed(2)}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <p style={{ marginTop: "12px" }}>
                  ¿Deseas actualizar este registro con los valores que acabas de llenar, o solo
                  generar el reporte sin tocar lo ya guardado?
                </p>
              </>
            )}
          </MDBModalBody>
          <MDBModalFooter>
            <MDBBtn
              color="secondary"
              size="sm"
              disabled={this.state.savingCierre}
              onClick={() => this.setState({ showConfirmModal: false, existingCierre: null })}
            >
              Solo Generar Reporte
            </MDBBtn>
            <MDBBtn
              color="primary"
              size="sm"
              disabled={this.state.savingCierre}
              onClick={() =>
                this.saveCierre(true, this.state.existingCierre.ID, this.state.cierreAgencia)
              }
            >
              Actualizar Registro
            </MDBBtn>
          </MDBModalFooter>
        </MDBModal>

        <ToastContainer
          hideProgressBar={true}
          newestOnTop={false}
          position={"bottom-right"}
          autoClose={3000}
        />
      </MDBContainer>
    );
  }
}

// El backend devuelve INSERT_DATE/UPDATE_DATE ya formateados como "DD/MM/YYYY HH:mm"
// (utils.processReportResponse), no como ISO — new Date() no lo parsea. Si en algún
// momento el backend cambia a ISO, el fallback de abajo lo sigue mostrando tal cual.
const formatBackendDate = (value) => {
  if (!value) return "";
  const m = String(value).match(/^(\d{2})\/(\d{2})\/(\d{4})\s+(\d{2}):(\d{2})$/);
  if (m) {
    return `${m[1]}/${m[2]}/${m[3]} ${m[4]}:${m[5]}`;
  }
  const d = new Date(value);
  return isNaN(d.getTime()) ? String(value) : d.toLocaleString("es-BO");
};

const CIERRE_MODAL_FIELDS = [
  { field: "DOTACION", label: "Dotación" },
  { field: "TIPO_CAMBIO", label: "Tipo de cambio" },
  { field: "CUAD_RET_DOT", label: "Retiro dotación" },
  { field: "CUAD_RET_EFEC", label: "Retiro efectivo" },
  { field: "CUAD_RET_USD", label: "Retiro USD" },
  { field: "RETIRO_TARJ_ATC", label: "Retiro tarj. ATC" },
  { field: "RETIRO_TARJ_LINK", label: "Retiro tarj. Linkser" },
  { field: "CONV_RET_QR_RED_ENLACE", label: "Retiro QR ATC" },
  { field: "CONV_RET_ISSA", label: "Retiro Línea de Crédito IISA" },
  { field: "CONV_RET_CONTRAENTREGA", label: "Retiro Contraentrega" },
  { field: "CONV_RET_TODOTIX", label: "Retiro TODOTIX" },
  { field: "CONV_RET_BCP", label: "Retiro QR BCP" },
];

export default reportArqueo2;

